var map = {
	"./Documentation.vue": [
		"S0Yg",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "J/x7";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/app/templates lazy ^\.\/.*\.vue$
// module id = J/x7
// module chunks = 2